import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Config } from './types';

const StyledSectionWidget = styled.div``;

const SectionWidget: React.FC<WidgetRenderProps<Config>> = (
  props: WidgetRenderProps<Config>
): ReactElement => {
  const {
    borderData,
    backgroundData,
    backgroundImage,
    boxShadowData,
    lineColor,
    boxShadowColor,
    visible,
    isCustomWidget,
  } = props.widgetState.config;

  if (visible === false || isCustomWidget) {
    return <></>;
  }

  return (
    <StyledSectionWidget
      data-test-id={'section-widget'}
      id={'sectionWidget'}
      className={'sectionWidget'}
      style={{
        backgroundColor:
          backgroundData?.color.startsWith('#') ||
          backgroundData?.color.startsWith('rgb')
            ? backgroundData?.color
            : '',
        backgroundImage:
          backgroundData?.style === 'Image'
            ? `url('${backgroundImage?.url}')`
            : backgroundData?.style === 'Color' &&
              !(
                backgroundData?.color.startsWith('#') ||
                backgroundData?.color.startsWith('rgb')
              )
            ? backgroundData?.color
            : '',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        borderWidth: `${borderData?.thickness}px`,
        borderTop: `${
          borderData?.isTopBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderBottom: `${
          borderData?.isBottomBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderLeft: `${
          borderData?.isLeftBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderRight: `${
          borderData?.isRightBorderVisible ?? true
            ? `${borderData?.thickness}px solid`
            : 'none'
        }`,
        borderColor: `${lineColor}`,
        borderRadius: `${borderData?.radius}px`,
        backgroundClip: 'content-box',
        boxShadow: `${boxShadowData?.horizontal}px ${boxShadowData?.vertical}px ${boxShadowData?.blurRadius}px ${boxShadowData?.spreadRadius}px ${boxShadowColor}`,
        width: '100%',
        height: '100%',
      }}
    />
  );
};
export default SectionWidget;
